var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pattern-container",attrs:{"title":_vm.patternName}},_vm._l((_vm.coloured),function(colour){return _c('div',{class:{ coloured: colour }})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624cc700","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/bingo-75/_components/pattern/current-pattern/current-pattern.html
// module id = null
// module chunks = 